// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__qhks2","item":"styles_item__NiMhQ","text":"styles_text__88UbC"};